import { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import AnimatedLetters from '../AnimatedLetters'
import PixelPortrait from '../PixelPortrait'
// import Logo from './Logo' // neon V paused while the hero portrait settles in
import profile from '../../data/profiles/activeProfile'
import './index.scss'

const { roles, techStack, tagline, status, currentCompany, stats } = profile.home
const [firstName, ...restName] = profile.displayName.split(' ')
const firstNameArray = firstName.split('')
const lastNameArray = restName.join(' ').split('')

const Home = () => {
  const [letterClass, setLetterClass] = useState('text-animate')

  // Typewriter state
  const [roleIndex, setRoleIndex] = useState(0)
  const [displayText, setDisplayText] = useState('')
  const [isDeleting, setIsDeleting] = useState(false)

  // Letter animation timeout
  useEffect(() => {
    const timer = setTimeout(() => {
      setLetterClass('text-animate-hover')
    }, 4000)
    return () => clearTimeout(timer)
  }, [])

  // Typewriter effect
  useEffect(() => {
    const currentRole = roles[roleIndex]
    let timer

    if (!isDeleting && displayText === currentRole) {
      // Fully typed — pause then start deleting
      timer = setTimeout(() => setIsDeleting(true), 2200)
    } else if (isDeleting && displayText === '') {
      // Fully deleted — advance to next role
      setIsDeleting(false)
      setRoleIndex((prev) => (prev + 1) % roles.length)
    } else if (!isDeleting) {
      // Type next character
      timer = setTimeout(() => {
        setDisplayText(currentRole.substring(0, displayText.length + 1))
      }, 80)
    } else {
      // Delete character
      timer = setTimeout(() => {
        setDisplayText(displayText.substring(0, displayText.length - 1))
      }, 45)
    }

    return () => clearTimeout(timer)
  }, [displayText, isDeleting, roleIndex])

  return (
    <div className="container home-page">
      {/* ── Ghost word backdrop ── */}
      <span className="home-ghost" aria-hidden="true">
        Developer
      </span>

      {/* ── Pixel-dithered portrait (activates once public/portrait.png exists) ── */}
      <PixelPortrait />

      <div className="text-zone">
        {/* ── Kicker ── */}
        <p className="hero-kicker">
          <span className="hero-kicker__rule" />
          Hi, I&apos;m
        </p>

        {/* ── Name ── */}
        <h1 className="hero-name">
          <span className="hero-name__line hero-name__first">
            <AnimatedLetters
              letterClass={letterClass}
              strArray={firstNameArray}
              idx={9}
            />
          </span>
          <span className="hero-name__line hero-name__last">
            <AnimatedLetters
              letterClass={letterClass}
              strArray={lastNameArray}
              idx={9 + firstNameArray.length}
            />
          </span>
        </h1>

        {/* ── Typewriter role ── */}
        <div className="hero-role">
          <span className="hero-role__prompt">&gt;</span>
          <span className="hero-role__text">{displayText}</span>
          <span className="hero-role__cursor" aria-hidden="true" />
        </div>

        {/* ── Value proposition ── */}
        <p className="hero-tagline">{tagline}</p>

        {/* ── CTAs ── */}
        <div className="hero-actions">
          <Link to="/projects" className="hero-btn" data-cursor="view">
            View my work <span className="hero-btn__arrow">↗</span>
          </Link>
          <Link to="/contact" className="hero-link" data-cursor="say hi">
            Contact me
          </Link>
        </div>

        {/* ── Tech stack line ── */}
        <p className="hero-tech">
          {techStack.map((tech, i) => (
            <span key={tech} className="hero-tech__item">
              {i > 0 && <span className="hero-tech__sep">/</span>}
              {tech}
            </span>
          ))}
        </p>
      </div>

      {/* <Logo /> */}

      {/* ── Bottom rail — stats · availability · company ── */}
      <footer className="home-rail">
        <div className="rail-stats">
          {stats.map((stat, i) => (
            <div key={stat.label} className="rail-stat">
              <span className="rail-stat__meta">
                <span className="rail-stat__index">
                  {String(i + 1).padStart(2, '0')}
                </span>
                {stat.label}
              </span>
              <span className="rail-stat__value">{stat.value}</span>
            </div>
          ))}
        </div>

        <div className="rail-status">
          <span className="rail-status__line">
            <span className="rail-status__dot" />
            {status}
          </span>
          {currentCompany && (
            <span className="rail-status__company">
              Currently&nbsp;@&nbsp;<strong>{currentCompany.name}</strong>
            </span>
          )}
        </div>
      </footer>
    </div>
  )
}

export default Home
